import { render } from "./PluginIndex.vue?vue&type=template&id=45120a7e"
import script from "./PluginIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Tools/PluginIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45120a7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45120a7e', __exports__)) {
    api.reload('45120a7e', __exports__)
  }
  
  module.hot.accept("./PluginIndex.vue?vue&type=template&id=45120a7e", () => {
    api.rerender('45120a7e', render)
  })

}


export default __exports__